export var POSITION_REPORT = "POSITION_REPORT";
export var POSITION_ERROR = "POSITION_ERROR";
export var POSITION_ERROR_HIDE = "POSTION_ERROR_HIDE";
export var POSITION_EMPTY_VALIDATION = "POSITION_EMPTY_VALIDATION";
export var POSITION_HIDE_EMPTY_VALIDATION = "POSITION_HIDE_EMPTY_VALIDATION";
